export default "__VITE_ASSET__B$uGbo8d__"